module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-14 at 2.08.40 PM (4).a71fa377.jpeg";